export default {
  getTypes (state) {
    return state.type
  },
  getQtys (state) {
    return state.qtys
  },
  getTimeHours (state) {
    return state.time_hours
  },
  getTimeMinutes (state) {
    return state.time_minutes
  },
  getMultipliers (state) {
    return state.multipliers
  }
}
